import { Eye, FileText } from 'lucide-react'
import { cn } from '@/lib/utils'

export type TranscriptViewerTab = 'transcript' | 'metadata'
export type PreviewMetadataTab = 'preview' | 'metadata'
export type ViewerTab = TranscriptViewerTab | PreviewMetadataTab

interface ViewerTabsTranscriptProps {
	activeTab: TranscriptViewerTab
	onTabChange: (tab: TranscriptViewerTab) => void
	/** Default when omitted. */
	leftTab?: 'transcript'
	tabTranscriptLabel: string
	tabMetadataLabel: string
}

interface ViewerTabsPreviewProps {
	activeTab: PreviewMetadataTab
	onTabChange: (tab: PreviewMetadataTab) => void
	leftTab: 'preview'
	tabPreviewLabel: string
	tabMetadataLabel: string
}

export type ViewerTabsProps = ViewerTabsTranscriptProps | ViewerTabsPreviewProps

export function ViewerTabs(props: ViewerTabsProps) {
	const tabMetadataLabel = props.tabMetadataLabel

	if (props.leftTab === 'preview') {
		const { activeTab, onTabChange, tabPreviewLabel } = props
		const leftLabel = tabPreviewLabel
		const isLeftActive = activeTab === 'preview'

		return (
			<div className="flex items-center w-fit gap-2 p-1 rounded-full bg-gray-100 dark:bg-gray-800">
				<button
					type="button"
					className={cn(
						'flex items-center gap-1 cursor-pointer px-3 py-1 rounded-full transition-colors',
						isLeftActive
							? 'bg-white dark:bg-gray-700 text-[#8c52ff] shadow'
							: 'bg-transparent text-gray-500 dark:text-gray-400'
					)}
					onClick={() => onTabChange('preview')}
					aria-pressed={isLeftActive}
					aria-label={leftLabel}
				>
					<Eye className="w-5 h-5" aria-hidden />
					{leftLabel}
				</button>
				<button
					type="button"
					className={cn(
						'flex items-center gap-1 cursor-pointer px-3 py-1 rounded-full transition-colors',
						activeTab === 'metadata'
							? 'bg-white dark:bg-gray-700 text-[#8c52ff] shadow'
							: 'bg-transparent text-gray-500 dark:text-gray-400'
					)}
					onClick={() => onTabChange('metadata')}
					aria-pressed={activeTab === 'metadata'}
					aria-label={tabMetadataLabel}
				>
					{tabMetadataLabel}
				</button>
			</div>
		)
	}

	const { activeTab, onTabChange, tabTranscriptLabel } = props
	const leftLabel = tabTranscriptLabel
	const isLeftActive = activeTab === 'transcript'

	return (
		<div className="flex items-center w-fit gap-2 p-1 rounded-full bg-gray-100 dark:bg-gray-800">
			<button
				type="button"
				className={cn(
					'flex items-center gap-1 cursor-pointer px-3 py-1 rounded-full transition-colors',
					isLeftActive
						? 'bg-white dark:bg-gray-700 text-[#8c52ff] shadow'
						: 'bg-transparent text-gray-500 dark:text-gray-400'
				)}
				onClick={() => onTabChange('transcript')}
				aria-pressed={isLeftActive}
				aria-label={leftLabel}
			>
				<FileText className="w-5 h-5" aria-hidden />
				{leftLabel}
			</button>
			<button
				type="button"
				className={cn(
					'flex items-center gap-1 cursor-pointer px-3 py-1 rounded-full transition-colors',
					activeTab === 'metadata'
						? 'bg-white dark:bg-gray-700 text-[#8c52ff] shadow'
						: 'bg-transparent text-gray-500 dark:text-gray-400'
				)}
				onClick={() => onTabChange('metadata')}
				aria-pressed={activeTab === 'metadata'}
				aria-label={tabMetadataLabel}
			>
				{tabMetadataLabel}
			</button>
		</div>
	)
}
